/**
 * Semantic icon map for Ninjanizr.
 *
 * Maps domain concepts to icon identifiers. All icon references
 * throughout the app should use these constants rather than
 * hardcoding icon library strings. If we switch icon libraries,
 * only this file needs to change.
 */
export const ICON = {
  // Navigation
  home: "i-lucide-house",
  menu: "i-lucide-menu",
  search: "i-lucide-search",
  arrowRight: "i-lucide-arrow-right",
  previous: "i-lucide-chevron-left",
  next: "i-lucide-chevron-right",

  // Domain objects
  item: "i-lucide-package",
  container: "i-lucide-archive",
  tag: "i-lucide-tags",
  itemType: "i-lucide-shapes",

  // Inventory
  inventoried: "i-lucide-check",
  toCatalog: "i-lucide-circle-alert",

  // Capture
  capture: "i-lucide-camera",
  scanQr: "i-lucide-scan-qr-code",
  manual: "i-lucide-pencil",
  mic: "i-lucide-mic",
  micOff: "i-lucide-mic-off",
  back: "i-lucide-arrow-left",
  check: "i-lucide-check",
  imagePlus: "i-lucide-image-plus",
  bulkCapture: "i-lucide-images",
  batches: "i-lucide-images",
  nextItem: "i-lucide-scan-line",
  history: "i-lucide-history",
  loading: "i-lucide-loader-circle",
  image: "i-lucide-image",
  noContainer: "i-lucide-circle-slash",
  flashOff: "i-lucide-zap-off",
  flashAuto: "i-lucide-zap",
  flashOn: "i-lucide-zap",

  // Actions
  add: "i-lucide-plus",
  edit: "i-lucide-square-pen",
  close: "i-lucide-x",
  more: "i-lucide-ellipsis",
  duplicate: "i-lucide-copy",
  print: "i-lucide-printer",
  export: "i-lucide-download",
  upload: "i-lucide-upload",
  archive: "i-lucide-file-archive",
  restore: "i-lucide-archive-restore",
  delete: "i-lucide-trash-2",
  link: "i-lucide-link",
  loan: "i-lucide-arrow-left-right",
  outing: "i-lucide-luggage",
  loanReturn: "i-lucide-undo-2",
  lentOut: "i-lucide-arrow-up-right",
  borrowedIn: "i-lucide-arrow-down-left",
  rotate: "i-lucide-rotate-cw",
  reset: "i-lucide-rotate-ccw",
  ai: "i-lucide-sparkles",

  // Users & accounts
  user: "i-lucide-user",
  signOut: "i-lucide-log-out",
  chevronRight: "i-lucide-chevron-right",
  chevronDown: "i-lucide-chevron-down",
  chevronUpDown: "i-lucide-chevrons-up-down",

  // Navigation & pages
  people: "i-lucide-users",
  members: "i-lucide-users",
  inventoryProgress: "i-lucide-clipboard-check",
  importExport: "i-lucide-hard-drive-download",
  sticker: "i-lucide-qr-code",
  settings: "i-lucide-settings",
  apiToken: "i-lucide-key-round",
  shield: "i-lucide-shield",
  help: "i-lucide-circle-help",
  sun: "i-lucide-sun",
  moon: "i-lucide-moon",
  monitor: "i-lucide-monitor",

  // Profile
  password: "i-lucide-key-round",

  // Status
  error: "i-lucide-circle-alert",
  success: "i-lucide-circle-check",

  // App
  logo: "i-lucide-package-search",
  dashboard: "i-lucide-layout-dashboard",
  sandbox: "i-lucide-flask-conical",
} as const

export type IconName = keyof typeof ICON

/**
 * Convert a bare Lucide icon name (e.g. "home") to the
 * Iconify identifier (e.g. "i-lucide-home").
 * Use for dynamic icon names stored in the database.
 */
export function lucideIcon(name: string): string {
  return `i-lucide-${name}`
}
